import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// Logical area: ModalValidationHandler General Strings
class Id {
  private constructor() {}

  public static readonly prefix = 'UI.webmodule-common.other.ui.ModalValidationHandler.';

  public static readonly validationReport = `${Id.prefix}validationReport`;
  public static readonly discardAndClose = `${Id.prefix}discardAndClose`;
  public static readonly close = `${Id.prefix}close`;
  public static readonly stayOnPage = `${Id.prefix}stayOnPage`;
  public static readonly discardChanges = `${Id.prefix}discardChanges`;
}

export class LangModalValidationHandler {
  private constructor() {}

  public static validationReport(): string {
    return interpolate(Id.validationReport);
  }

  public static discardAndClose(): string {
    return interpolate(Id.discardAndClose);
  }

  public static close(): string {
    return interpolate(Id.close);
  }

  public static stayOnPage(): string {
    return interpolate(Id.stayOnPage);
  }

  public static discardChanges(): string {
    return interpolate(Id.discardChanges);
  }
}

export class ModalValidationHandlerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // General
    register.add(Id.validationReport, 'Validation Report', 'Validation report dialog title');
    register.add(Id.discardAndClose, 'Discard & Close', 'Discard and close button');
    register.add(Id.close, 'Close', 'Close button');
    register.add(Id.stayOnPage, 'Stay on page', 'Stay on page button');
    register.add(Id.discardChanges, 'Discard Changes', 'Discard changes button');
  }
}
